import SideBySideTabsAndTestimonialTabsConfig from "./side-by-side-tabs-and-testimonial-tabs-config";
import SideBySideTabsAndTestimonialTabsAdvancedConfig from "./side-by-side-tabs-and-testimonial-tabs-advanced-config";
import dynamic from "next/dynamic";

const SideBySideTabsAndTestimonialTabsComponent = dynamic(() =>
  import("./side-by-side-tabs-and-testimonial-tabs-component")
);

export default {
  SideBySideTabsAndTestimonialTabsComponent,
  SideBySideTabsAndTestimonialTabsConfig,
  SideBySideTabsAndTestimonialTabsAdvancedConfig
};
